module.exports = __webpack_public_path__ + "assets/816cd22990c19c2a8f0d07a0addcc05a.mp4";